import { Col, Row, Text, CMSLayout, useUIState, RangeDatePicker, Select01, useRefState, modal, Button, showPopupMessage } from 'components';
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { IScreen, TCMSOrder } from 'type';
import Store from 'store';
import { useNavFunc } from 'navigation';
import { SCREEN } from 'const';
import { DatePicker } from 'antd';
import { TimeHelper, ValHelper } from 'helpers';
import { ListOrdersTabs } from './ListOrders.Tabs';
import { commonFuncs } from './ListOrders.funcs';
import { ListOrderLoadMore, ListOrderLoading } from './ListOrders.Comps';
import { downloadArtworkAndPackingSlip } from 'helpers/FileHelper';
import ToastHelper from 'helpers/ToastHelper';
import RejectOrderModal from './RejectOrderModal';
import { useEvent } from 'js-events-listener/react';
import OrderTable from './OrderTable2';
import { Tooltip } from 'react-tippy';
import dayjs, { Dayjs } from 'dayjs';
import { ActivityIndicator, ScrollView, useWindowDimensions } from 'react-native';
import { kebabCase, capitalize } from 'lodash';
import { OrderActionButtons } from './components/OrderActionButtons';
const { RangePicker } = DatePicker;

const defaultRange = [dayjs().startOf("year"), dayjs().endOf("year")];

const isCloseToBottom = ({ layoutMeasurement, contentOffset, contentSize }: any) => {
  return layoutMeasurement.height + contentOffset.y >= contentSize.height - 100
    && contentSize.height > 100
    && contentOffset.y > 100;
};

const ListOrders: IScreen = ({ resellerId = 'all', breadcrumbs }) => {
  const { navigation, route } = useNavFunc();
  // @ts-ignore
  const stage = route.params?.stage;
  const stageRef = useRef('');
  const rejectModalRef = useRef(null);
  const UserStore = Store.useUserStore();
  const ShopStore = Store.useShopStore();
  const { user } = UserStore;
  // const resellerId = user?.role === 'admin' ? 'all' : user?.role === 'reseller' ? user?.id
  //   : user.resellerId;

  const OrderStore = Store.useOrderStore();
  // @ts-ignore
  window.OrderStore = OrderStore;
  const [{ fetching, errorMes, loading: btnLoading }, setUI] = useUIState({ fetching: false });
  const [pagination, setPagination] = useState({ hasNext: false, total: 1 });
  const [jobs, getJobs, setJobs] = useRefState<Array<TCMSOrder>>([]);
  const [selectedJobs, setSelectedJobs] = useState<{ [id: string]: boolean }>({});
  const { height: screenHeight } = useWindowDimensions();
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const sorter = useRef();
  const filter = useRef();
  const layoutTable = useRef();
  const layoutContainer = useRef();
  const [containerHeight, setContainerHeight] = useState(0);
  const [filterTimeRange, setFilterTimeRange] = useState<Dayjs[]>(defaultRange);

  const [showOnlyInproduction, setShowOnlyInproduction] = useState<true | false | undefined>();

  const atLeastOneSelected = useMemo(() => {
    return Object.keys(selectedJobs).filter(id => !!selectedJobs[id]).length > 0;
  }, [selectedJobs]);

  const getData = useCallback(async (p, isForce = false) => {
    try {
      if (isForce) setJobs([]);
      // const fetchingStatus = getJobs().length === 0 || stageRef.current !== stage ? true : false;
      stageRef.current = stage;
      if (p <= 1) setUI({ fetching: true, errorMes: '' });
      if (p !== 1) setIsLoadingMore(true);
      // await TimeHelper.wait(300);
      const Stage = ValHelper.toDisplayStage(stage);
      // fetch pipelines first to match later
      const filterRange = { startDate: filterTimeRange?.[0]?.toISOString(), endDate: filterTimeRange?.[1]?.toISOString() };
      // await OrderStore.getListPipeline(p, filterRange);
      const { list, hasNext, total, error } = await OrderStore.getListOrder(p, Stage, filterRange, resellerId, {
        filter: filter.current,
        sorter: sorter.current,
      });
      if (error) return setUI({ fetching: false, errorMes: error });
      setPage(p);
      setPagination({ hasNext, total });
      setJobs(p === 1 ? list : [
        ...getJobs(),
        ...list,
      ]);
      setUI({ fetching: false, errorMes: '' });
      setIsLoadingMore(false);
      if (hasNext) {
        setTimeout(() => {
          // @ts-ignore
          if (layoutContainer.current?.height > layoutTable.current?.height) {
            TimeHelper.throttle(() => getData(p + 1))();
          }
        }, 500);
      }
    } catch (err) {
      setUI({ fetching: true, errorMes: String(err) });
    }
  }, [stage, filterTimeRange, resellerId]);

  useEvent('REFRESH_LIST_ORDERS', () => {
    getData(1, true);
  }, [getData]);

  // console.log(jobs, 'jobs');

  useEvent('ORDER_UPDATE_TO_FULFILLED', ({ orderId, orderData }: any) => {
    if (stage === 'in-production') {
      // remove order from list
      setJobs(v => v.filter(j => j['Order ID'] !== orderId));
      return;
    }
    if (stage === 'fulfillment') {
      // add order to list
      setJobs(v => {
        const findIndex = v.findIndex(j => j['Order ID'] === orderId);
        return findIndex === -1 ? [orderData, ...v] : v;
      });
      return;
    }
  }, [stage]);

  useEffect(() => {
    if (!stage || stage === 'undefined') {
      navigation.navigate(resellerId !== 'all' ? SCREEN.ListOrderForReseller : SCREEN.ListOrders, { stage: "all" });
      return;
    }
    if (stage === 'recycling-bin') {
      navigation.navigate(SCREEN.DeletedOrders);
      return;
    }
    // will getData when screen is focused
    const unsubscribe = navigation.addListener('focus', () => {
      getData(1);
    });
    getData(1);
    return unsubscribe;
  }, [stage, resellerId, filterTimeRange]);

  const listSelected = useMemo(() => {
    return Object.keys(selectedJobs).map(stringId => {
      if (!selectedJobs[stringId]) return undefined;
      const findJob = jobs.find(val => `${val.Id}_${val['Order ID']}` === stringId);
      return findJob;
    }).filter(Boolean);
  }, [selectedJobs, jobs]);

  useEffect(() => {
    UserStore.getListResellers(1);
    ShopStore.getList(1);
  }, [])

  const inProductionOptions = [
    { label: 'All', value: undefined },
    { label: 'In production', value: true },
    { label: 'Accepted', value: false },
  ]

  const displayJobs = useMemo(() => (
    jobs.filter(j => {
      if (user?.role !== 'admin' && j['Client ID'] !== UserStore.getResellerId(user)) {
        console.log('client id not match', j['Client ID'], UserStore.getResellerId(user));
        return false;
      }
      if (j.Pipelines.length === 0) {
        console.log('EMPTY PIPELINE', j.Pipelines.length, j['Order ID']);
        return false;
      }
      if (j.Pipelines[j.Pipelines.length - 1]?.SharedData?.skipped) return false;
      // if (status !== j.Status.toLowerCase()) {
      //   console.log('wrong status', status, j.Status.toLowerCase());
      //   return false;
      // }
      // if (status !== 'accepted') return true;
      if (showOnlyInproduction === undefined) return true;
      if (showOnlyInproduction === true) {
        return j.Pipelines?.[j.Pipelines?.length - 1]?.SharedData.isInProduction === true;
      }
      return !j.Pipelines?.[j.Pipelines?.length - 1]?.SharedData.isInProduction;
    })
  ), [jobs, stage, showOnlyInproduction, user]);
  // console.log('displayJobs', displayJobs);

  const onScroll = (e) => {
    if (isCloseToBottom(e.nativeEvent)) {
      if (pagination.hasNext) {
        console.log("load more");
        TimeHelper.throttle(() => getData(page + 1))();
      }
    }
  };

  const onLayoutTable = (e) => layoutTable.current = e.nativeEvent?.layout;
  const onLayoutContainer = (e) => layoutContainer.current = e.nativeEvent?.layout;

  return (
    <CMSLayout
      breadcrumbs={breadcrumbs || [
        { title: 'Orders' },
      ]}
    >
      <Row marginBottom={0} ph2 bgWhite alignItems={'flex-start'}
        onLayout={(e) => {
          const height = e.nativeEvent.layout.height;
          setContainerHeight(screenHeight - height - 55);
        }}
      >
        <ListOrdersTabs
          activeTab={stage}
          mr1
          flex1
          searchPlaceholder='Search order, email, product name..'
          onSearchInput={(query) => {
            if (!query) return showPopupMessage({
              title: '',
              content: 'Please fill in order number, email or product name',
              buttonOkText: 'OK',
              // 
              typeHighlight: 'warning',
              contentHighlight: 'Fill information'
            });
            // alert('Please fill in order number, email or product name');
            navigation.navigate(SCREEN.OrderSearchResult, { query })
          }}
          onChangeTab={(newKey) => {
            setSelectedJobs({});
            navigation.navigate(resellerId !== 'all' ? SCREEN.ListOrderForReseller : SCREEN.ListOrders, { stage: kebabCase(newKey) });
          }}
          renderAction={(
            atLeastOneSelected ? (
              <Col marginLeft={24} marginTop={-14}>
                <OrderActionButtons
                  stage={stage}
                  rejectJob={() => {
                    rejectModalRef.current?.show();
                  }}
                  listSelected={listSelected}
                  onDeleteSuccess={() => {
                    setJobs(l => l.filter(val => !selectedJobs[`${val.Id}_${val['Order ID']}`]));
                    setSelectedJobs({});
                  }}
                />
              </Col>
            ) : <Col></Col>
          )}
        />
      </Row>
      <ScrollView style={{ height: containerHeight }} onScroll={onScroll} onLayout={onLayoutContainer} scrollEventThrottle={60}>
        <Col flex1 m2 mv1 pt1 bgWhite round1>
          {errorMes ? (
            <Col flex1 middle>
              <Text color="red" subtitle1>{errorMes}</Text>
            </Col>
          ) : (
            <Col>
              <Row justifyContent="flex-end" p1>
                <Row>
                  {/* {stage === 'in-production' && (
                    <Col width={200} bgWhite round0 borderThin mr1>
                      <Select01
                        placeholder='Filter'
                        options={inProductionOptions}
                        value={inProductionOptions.find(v => v.value === showOnlyInproduction)}
                        onChange={(newData) => setShowOnlyInproduction(newData.value)}
                        backgroundColor='white'
                        height={30}
                      />
                    </Col>
                  )} */}
                  {/* @ts-ignore */}
                  <RangePicker
                    onChange={setFilterTimeRange}
                    allowClear={false}
                    allowEmpty={false}
                    value={filterTimeRange?.length ? filterTimeRange : defaultRange}
                    size="large"
                  />
                </Row>
              </Row>
              <OrderTable
                isLoading={fetching}
                jobs={displayJobs}
                setJobs={setJobs}
                onRefresh={() => getData(1)}
                stage={stage}
                onChangeFilter={(_, _filter, _sorter) => {
                  sorter.current = _sorter;
                  filter.current = _filter;
                  getData(1);
                }}
                selectedJobs={selectedJobs}
                setSelectedJobs={setSelectedJobs}
                onLayout={onLayoutTable}
              />
              {isLoadingMore && (
                <Col middle padding={10}>
                  <ActivityIndicator />
                </Col>
              )}
              {/* <ListOrderLoadMore
                hasNext={pagination.hasNext}
                getData={getData}
                page={page}
                isLoadingMore={isLoadingMore}
              /> */}
            </Col>
          )}
        </Col>
      </ScrollView>
      <RejectOrderModal
        selectedOrders={listSelected}
        ref={rejectModalRef}
      />
    </CMSLayout>
  )
};

ListOrders.routeInfo = {
  title: 'Orders - IT Luggage',
  path: '/list-orders/:stage',
};

export default ListOrders;
